var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSaturn({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.264 18.171c4.366 0 7.905-3.472 7.905-7.756 0-.793-.121-1.56-.347-2.28-.502 1.994-1.858 4.254-3.897 6.223-1.846 1.782-3.912 2.997-5.778 3.532a8.056 8.056 0 002.117.281zm-7.514-5.34c.013-.05.027-.098.042-.148.099.391.28.733.547 1.01 1.453 1.505 4.92.514 7.745-2.214 2.825-2.728 3.936-6.159 2.483-7.663a2.236 2.236 0 00-1.072-.605c.142-.039.283-.073.422-.104a8.029 8.029 0 00-2.653-.448c-4.366 0-7.905 3.473-7.905 7.756 0 .844.137 1.656.391 2.416z",
    fill: "#8489FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.915 16.331c1.22 2.032 7.107.736 13.148-2.893 6.04-3.63 9.947-8.22 8.727-10.25-.781-1.3-3.472-1.238-6.891-.074.687.115 1.207.4 1.487.866.939 1.562-1.188 4.564-4.75 6.705-3.563 2.14-7.211 2.609-8.15 1.046-.302-.503-.287-1.154-.009-1.878-2.892 2.602-4.38 5.116-3.562 6.478z",
    fill: "#8489FF"
  })));
}

export default SvgSaturn;